import styles from "./EditMapSize.module.css";

export default function EditMapSize({ level }) {
  return (
    <>
      <p className={styles.row}>
        <button
          className={styles.sizeButton}
          onClick={() => {
            level.editor.updateTilesWidth(-1);
          }}
        >
          -
        </button>
        <span>Width: {level.tilesWidth}</span>
        <button
          className={styles.sizeButton}
          onClick={() => {
            level.editor.updateTilesWidth(1);
          }}
        >
          +
        </button>
      </p>
      <p className={styles.row}>
        <button
          className={styles.sizeButton}
          onClick={() => {
            level.editor.updateTilesHeight(-1);
          }}
        >
          -
        </button>
        <span>Height: {level.tilesHeight}</span>
        <button
          className={styles.sizeButton}
          onClick={() => {
            level.editor.updateTilesHeight(1);
          }}
        >
          +
        </button>
      </p>
    </>
  );
}
